import Icons_Repository from '../Icons/Icons_Repository';
import './Candidate_Slot_Already_Booked.css';

interface CandidateInterviewSlotProps {
  setSlotAlreadyBookedPopup: (val: boolean) => void;
}


function Candidate_Slot_Already_Booked({setSlotAlreadyBookedPopup}: CandidateInterviewSlotProps){
    return (
    <div className="main-popup-container">
      <div className="slotbooked-cancel-popup-card">
        <div className="popup-header">
          <div className="cancel-button-parent">
            <div
              className="close-button"
              onClick={() => {
                setSlotAlreadyBookedPopup(false);
                window.location.reload();
              }}
            >
              <Icons_Repository iconName="x" />
            </div>
          </div>
        </div>

        <div className="slotbooked-cancel-section">
          <div className="slotbooked-cancel-text-container">
            <div className="slotbooked-cancel-text">
              The Selected Slot is Already Booked
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
}
export default Candidate_Slot_Already_Booked;